<template>
  <div v-loading="loading">
    <el-card class="mat12">
      <div class="table_box">
        <div class="table_wrap">
          <div class="table_head">
            <div class="table-th">岗位名称</div>
            <div class="table-th">岗位位置</div>
            <div class="table-th">值岗类型</div>

            <div class="table-th">岗位补助</div>
            <div class="table-th">班次</div>

            <div class="table-th"></div>
          </div>
          <div v-for="(item,index) in data" :key="index">
            <div class="table_tbody">
              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{item.postName}}</span></div>
              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{item.position?item.position:'未填写'}}</span></div>
              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{getPostType(item.postType)}}</span></div>

              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{item.postSubsidy?item.postSubsidy:'0'}}元</span></div>
              <div class="table-tb"> <span :class="item.delState == 1 ?'grey':''">{{item.codeStr | filterString}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card_footer_info">
        <div class="footer_bc">
          <span class="font_word">项目补助：</span>
          <span>{{dataDesc.project.subsidy ? dataDesc.project.subsidy : 0}}元/月 &nbsp;&nbsp;</span>
           <span class="font_word">临时员工补助：</span>
          <span>{{dataDesc.project.temporarySubsidy ? dataDesc.project.temporarySubsidy  : 0}}元/天 &nbsp;&nbsp;</span>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'CardProjectWagestand',
  props: {
    dataDesc: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      data: {},
      value: '',
      loading: false,
      hoursList: [], // 表示几个班次
      totalHours: '' // 总时长
    }
  },
  created () {
    if (this.dataDesc.postDetail) {
      this.getListPost(this.dataDesc.postDetail.post)
    } else {
      this.getListPost(this.dataDesc.post)
    }
  },

  filters: {
    filterString: function (value) {
      if (value) {
        return value.join(',')
      } else {
        return value
      }
    }
  },
  methods: {
    // 获取岗位及工时处理
    getListPost (val) {
      this.data = val.map(item => {
        item.isShow = false
        return item
      }).sort((a, b) => {
        return a.delState - b.delState
      })
      // .filter(item => {
      //   return item.delState !== 1
      // })
    },

    getPostType (postType) {
      switch (postType) {
        case 1:
          return '普通保安岗'
        case 2:
          return '形象岗'
        case 3:
          return '中控岗'
        case 4:
          return '班长岗'
        case 5:
          return '副队长岗'
        case 6:
          return '兼职队长岗'
        case 7:
          return '专职队长岗'
        default:
          return '普通保安岗'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.head {
  font-weight: bold;
  color: #333;
  padding: 0 10px 10px;
  .team {
    font-weight: 400;
  }
}

.table_box {
  width: 100%;
  padding-bottom: 20px;
  .table_head {
    width: 100%;
    border-bottom: 1px solid #ebeef5;
    padding: 12px;
    line-height: 30px;
    display: flex;
    // justify-content: space-between;
    flex-wrap: nowrap;
    box-sizing: border-box;
    .table-th {
      color: #909399;
      font-weight: bold;
      width: 200px;
      flex-shrink: 0;
    }
  }
  .table-text {
    color: #909399;
    font-weight: bold;
  }
  .table_tbody {
    width: 100%;
    overflow: hidden;
    border-bottom: 1px solid #ebeef5;
    padding: 12px;
    display: flex;
    // justify-content: space-between;
    box-sizing: border-box;
    flex-wrap: nowrap;

    .table-tb {
      color: #333;
      width: 200px;
      flex-shrink: 0;
    }
  }

  .table_desc {
    cursor: pointer;

    i {
      transition: transform 0.2s ease-in-out;
    }
  }
  .table_desc.active {
    i {
      transform: rotate(180deg);
    }
  }
  .table_arrow_data {
    padding: 20px 12px;
    border-bottom: 1px solid #ebeef5;

    .table_arrow_list {
      .item {
        // padding: 0 0 15px 0;
        margin: 15px 0;
        height: auto;
        overflow: hidden;
        .name {
          font-size: #333;
        }
      }
      .item_flex {
        // max-width: 50%;
        margin: 5px 0;
        float: left;
      }
      .item_day {
        color: #999;
      }
      span {
        padding: 0 10px 0 0;
      }
      i {
        font-style: normal;
      }
    }
  }
}
.bc-title {
  // width: 56px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999;
  line-height: 40px;
}
.card_footer_info {
  padding: 5px 12px;
  display: flex;
  .footer_bc {
    color: #333;
    // width: calc(42% + 298px);
    // width: calc(26% + 298px);
        width: calc(19% + 458px);
  }
  .font_word,
  .footer_ht,
  .footer_gs {
    font-weight: bold;
  }
}

@media screen and (max-width: 880px) {
  .table_box {
    overflow-x: scroll;
  }
  .table_box .table_head .table-th {
    width: 100px;
  }
  .table_box .table_tbody .table-tb {
    width: 100px;
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
    // border-top: 1px solid #ebeef5;
  }
  .table_box .table_head .table-th {
    padding-bottom: 20px;
    border-bottom: 1px solid #ebeef5;
  }
  .table_box .table_head {
    border-bottom: none;
  }
  .table_box .table_arrow_data {
    border-bottom: none;
  }
  .table_box .table_tbody {
    overflow: initial;
    border-bottom: none;
  }
}
</style>
